export async function UTCToTimeZone(DateValue, Time) {
  if (DateValue == null || Time == null) {
    return {
      Date: null,
      Time: null,
    };
  }

 

  //Gary Version //
  let testnewdtime = DateValue.split('/')
  let testnewtime = Time.split(':')
  let month = testnewdtime[1] - 1; //Javascript months are 0-11
  let datereformat = new Date(testnewdtime[2], month, testnewdtime[0],testnewtime[0],testnewtime[1],testnewtime[2]);
  //Gary Version End //

   // let TimeDateObject = DateValue + ", " + Time; // Reinstate if removing Gary Code
  const dt = new Date();
  let diffTZ = dt.getTimezoneOffset();
  // let newDate = new Date(TimeDateObject); // Reinstate if removing Gary Code

  // let timeinseconds = Math.floor(new Date(newDate).getTime() / 1000); // Reinstate if removing Gary code

  let timeinseconds = Math.floor(new Date(datereformat).getTime()/1000) // remove if removing Gary Code

  let timezoneoffsetseconds = diffTZ * 60;

  let offsetTimeSecs = timeinseconds - timezoneoffsetseconds;

  let offsetDate = new Date(offsetTimeSecs * 1000);
  const nlBEFormatter = new Intl.DateTimeFormat("nl-BE");
  let offsetDateString = offsetDate.toString();
  let position = offsetDateString.search(/:/);
  let offsetTime = offsetDateString.slice(position - 2, position + 6);
  let offsetDateObject = {
    Date: nlBEFormatter.format(offsetDate),
    Time: offsetTime,
  };
  return offsetDateObject;
}

export async function TimeZoneTOUTC(DateValue, Time) {
  if (DateValue == null || Time == null) {
    return {
      Date: null,
      Time: null,
    };
  }

  //Gary Version //
  let testnewdtime = DateValue.split('/')
  let testnewtime = Time.split(':')
  let month = testnewdtime[1] - 1; //Javascript months are 0-11
  let datereformat = new Date(testnewdtime[2], month, testnewdtime[0],testnewtime[0],testnewtime[1],testnewtime[2]);
  //Gary Version End //

  //let TimeDateObject = DateValue + ", " + Time; // Reinstate if removing Gary Code

  const dt = new Date();
  let diffTZ = dt.getTimezoneOffset();
  //let newDate = new Date(TimeDateObject); // Reinstate if removing Gary Code

 //let timeinseconds = Math.floor(new Date(newDate).getTime() / 1000); //Reinstate if removing Gary code

  let timeinseconds = Math.floor(new Date(datereformat).getTime()/1000) // remove if removing Gary Code


  let timezoneoffsetseconds = diffTZ * 60;

  let offsetTimeSecs = timeinseconds + timezoneoffsetseconds;

  let offsetDate = new Date(offsetTimeSecs * 1000);

  const nlBEFormatter = new Intl.DateTimeFormat("nl-BE");
  let offsetDateString = offsetDate.toString();
  let position = offsetDateString.search(/:/);

  let offsetTime = offsetDateString.slice(position - 2, position + 6);

  let offsetDateObject = {
    Date: nlBEFormatter.format(offsetDate),
    Time: offsetTime,
  };

  return offsetDateObject;
}
